
import * as Hammer from './Hammerjs';
import { HammerGestureConfig } from '@angular/platform-browser';


export class MyHammerConfig extends HammerGestureConfig {
  //Para que funcione el Scroll Vertical
  overrides = <any> {
    'pinch': { enable: false },
    'rotate': { enable: false }
  }
}
